export default () => {
    const bootElement = document.querySelector('[type="text/json"]');

    if (!bootElement) {
        console.log('Could not find the expected boot script tag with type "text/json".');
        return {};
    }

    try {
        return JSON.parse(bootElement.innerText);
    }
    catch (e) {
        console.log('Unable to parse the boot json. Specific error:');
        console.log(e);
        return {};
    }
};
